const COUNTRY_CODES = [
    'and',
    'are',
    'afg',
    'atg',
    'aia',
    'alb',
    'arm',
    'ant',
    'ago',
    'ata',
    'arg',
    'asm',
    'aut',
    'aus',
    'abw',
    'ala',
    'aze',
    'bih',
    'brb',
    'bgd',
    'bel',
    'bfa',
    'bgr',
    'bhr',
    'bdi',
    'ben',
    'blm',
    'bmu',
    'brn',
    'bol',
    'bes',
    'bra',
    'bhs',
    'btn',
    'bvt',
    'bwa',
    'blr',
    'blz',
    'can',
    'cck',
    'cod',
    'caf',
    'cog',
    'che',
    'civ',
    'cok',
    'chl',
    'cmr',
    'chn',
    'col',
    'cri',
    'cub',
    'cpv',
    'cuw',
    'cxr',
    'cyp',
    'cze',
    'deu',
    'dji',
    'dnk',
    'dma',
    'dom',
    'dza',
    'ecu',
    'est',
    'egy',
    'esh',
    'eri',
    'esp',
    'eth',
    'fin',
    'fji',
    'flk',
    'fsm',
    'fro',
    'fra',
    'fxx',
    'gab',
    'gbr',
    'grd',
    'geo',
    'guf',
    'ggy',
    'gha',
    'gib',
    'grl',
    'gmb',
    'gin',
    'glp',
    'gnq',
    'grc',
    'sgs',
    'gtm',
    'gum',
    'gnb',
    'guy',
    'hkg',
    'hmd',
    'hnd',
    'hrv',
    'hti',
    'hun',
    'idn',
    'irl',
    'isr',
    'imn',
    'ind',
    'iot',
    'irq',
    'irn',
    'isl',
    'ita',
    'jey',
    'jam',
    'jor',
    'jpn',
    'ken',
    'kgz',
    'khm',
    'kir',
    'com',
    'kna',
    'prk',
    'kor',
    'kwt',
    'cym',
    'kaz',
    'lao',
    'lbn',
    'lca',
    'lie',
    'lka',
    'lbr',
    'lso',
    'ltu',
    'lux',
    'lva',
    'lby',
    'mar',
    'mco',
    'mda',
    'mne',
    'mdg',
    'mhl',
    'mkd',
    'mli',
    'mmr',
    'mng',
    'mac',
    'mnp',
    'mtq',
    'mrt',
    'msr',
    'mlt',
    'mus',
    'mdv',
    'mwi',
    'mex',
    'mys',
    'moz',
    'nam',
    'ncl',
    'ner',
    'nfk',
    'nga',
    'nic',
    'nld',
    'nor',
    'npl',
    'nru',
    'niu',
    'nzl',
    'omn',
    'pan',
    'per',
    'pyf',
    'png',
    'phl',
    'pak',
    'pol',
    'spm',
    'pcn',
    'pri',
    'pse',
    'prt',
    'plw',
    'pry',
    'qat',
    'reu',
    'rou',
    'srb',
    'rus',
    'rwa',
    'sau',
    'slb',
    'syc',
    'sdn',
    'swe',
    'sgp',
    'shn',
    'svn',
    'sjm',
    'svk',
    'sle',
    'smr',
    'sen',
    'som',
    'sur',
    'stp',
    'slv',
    'sxm',
    'syr',
    'swz',
    'tca',
    'tcd',
    'atf',
    'tgo',
    'tha',
    'tjk',
    'tkl',
    'tls',
    'tkm',
    'tun',
    'ton',
    'tur',
    'tto',
    'tuv',
    'twn',
    'tza',
    'ukr',
    'uga',
    'umi',
    'usa',
    'ury',
    'uzb',
    'vat',
    'vct',
    'ven',
    'vgb',
    'vir',
    'vnm',
    'vut',
    'wlf',
    'wsm',
    'yem',
    'myt',
    'zaf',
    'zmb',
    'zwe'
];

export default COUNTRY_CODES;